module.exports = __webpack_public_path__ + "static/media/merriweather-v21-latin-regular.69f09800.woff";